import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterOutlet, Router } from '@angular/router';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { MatButtonModule } from '@angular/material/button';
import { AuthService } from './services/auth.service';
import { CookieConsentComponent } from './components/cookie-consent/cookie-consent.component';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [
    CommonModule,
    RouterOutlet,
    MatToolbarModule,
    MatIconModule,
    MatMenuModule,
    MatButtonModule,
    CookieConsentComponent,
  ],
  template: `
    <div class="container">
      <!-- Sticky Header with Logo & Title -->
      <mat-toolbar class="sticky-header">
        <img src="assets/NewLogo.webp" alt="Chareety" class="toolbar-logo">
        <h1 class="toolbar-app-name">Onboarding</h1>
        <span class="toolbar-spacer"></span>
        
        <!-- User Menu (only visible when authenticated) -->
        <button mat-icon-button [matMenuTriggerFor]="userMenu" *ngIf="(authService.isAuthenticated$ | async)">
          <mat-icon>account_circle</mat-icon>
        </button>
        <mat-menu #userMenu="matMenu">
          <button mat-menu-item (click)="logout()">
            <mat-icon>logout</mat-icon>
            <span>Sign Out</span>
          </button>
        </mat-menu>
      </mat-toolbar>

      <!-- Main Content -->
      <router-outlet></router-outlet>
    </div>
    <app-cookie-consent></app-cookie-consent>
  `,
  styleUrl: './app.component.scss'
})
export class AppComponent {
  constructor(public authService: AuthService, private router: Router) {}

  async logout(): Promise<void> {
    try {
      await this.authService.logout();
      await this.router.navigate(['/login']);
    } catch (error) {
      console.error('Logout error:', error);
      this.router.navigate(['/login']);
    }
  }
}
